import { ReactElement, ReactNode } from 'react'

interface Props {
    children: ReactNode
    className?: string
}

export const AuthFlowContentSpacing = ({ children, className }: Props): ReactElement => (
    <div className={`p-8 xs:p-12 sm:p-24 max-w-xl ${className ?? ''}`}>{children}</div>
)
